import * as React from 'react';
import styled from "styled-components";
import {Title} from "../../../styled"
import Person1 from '../../../images/person/1.png';
import Person2 from '../../../images/person/2.png';
import Person3 from '../../../images/person/3.png';
import Person4 from '../../../images/person/4.png';

interface Item {
  title: string;
  icon: string;
  description: string;
}

const Container = styled.div`
  display: grid;
  gap: 30px;
  
  ${Title} {
    max-width: none;
    margin-top: 40px;

    @media screen and (max-width: 580px) {
      padding-bottom: 10px;
      margin-bottom: 14px;
      border-bottom: 1px solid #29292B;
    }
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 260px);
  gap: 40px;

  @media screen and (max-width: 580px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    gap: 14px;
  }
`

const ItemBox = styled.div`
  text-align: center;
  max-width: 260px;
`

const ItemIconBox = styled.div`
  margin: 0 auto 10px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const ItemTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
  margin-bottom: 8px;
`

const ItemDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #67686B;
`

/**
 * render landing page platform teachers section
 * @constructor
 */
export default function Teachers(): React.ReactElement {

  const items: Item[] = [
    {
      icon: Person1,
      title: 'Основатели',
      description: 'Промо, upsale, cross-sell, OTO и другие инструменты 2 в клика',
    },
    {
      icon: Person2,
      title: 'Маркетологи',
      description: 'Мощный промо-блок для быстрой реализации воронки и дополнительных продаж, аналитика',
    },
    {
      icon: Person3,
      title: 'Преподаватели',
      description: 'Функциональное и удобное создание заданий, а также их проверка и система авто-проверки заданий',
    },
    {
      icon: Person4,
      title: 'Администраторы',
      description: 'Высокая скорость работы с платформой и доступ с любого устройства, быстрая и дружелюбная поддержка',
    },
  ]

  function renderItem(item: Item) {
    return (
      <ItemBox key={item.title}>
        <ItemIconBox>
          <img src={item.icon} alt={item.title}/>
        </ItemIconBox>
        <ItemTitle>{item.title}</ItemTitle>
        <ItemDescription>{item.description}</ItemDescription>
      </ItemBox>
    )
  }

  return (
    <Container>
      <Title>
        При разработке мы учитывали
        <span> потребности реальных</span> людей,
        которые ежедневно работают с онлайн школой:
      </Title>
      <Content>
        {items.map(renderItem)}
      </Content>
    </Container>
  );
}
